const geoData = window.geoData;
const { dropdownSettings, modalSettings, stores } = geoData;
const currentStoreData = stores.find(x => x.isCurrentStore == true);
const externalStoresData = stores.filter(x => x.isCurrentStore == false);






/**************************** Helper ****************************/
function populateStoreElem(template, storeObj, showTitle = true, showImage = true, lazyImg = true) {

    const regionalImg = template.querySelector('[data-store-image]');
    const regionalText = template.querySelector('[data-store-title]');
    template.setAttribute('href', storeObj.link)

    if (storeObj['highlight'] !== null && storeObj.highlight === true)
    {
        template.classList.add('highlight');
    }

    if (showImage)
    {
        regionalImg.setAttribute('src', storeObj.imageSrc);
        regionalImg.setAttribute('alt', storeObj.title);
        if (lazyImg)
        {
            regionalImg.setAttribute('loading', 'lazy');
        }
    }
    else
    {
        regionalImg.remove();
    }

    if (showTitle)
    {
        regionalText.innerText = storeObj.title;
    }
    else
    {
        regionalText.remove();
    }

    return template

}




/**************************** Dropdown ****************************/

const geoDropdowns = document.querySelectorAll('.js-geo-dropdown')
if (geoDropdowns && geoData)
{
    // Open selector 
    const openGeoDropdown = (elem) => { elem.classList.add('open') };
    // Close selector 
    const closeGeoDropdown = (elem) => { elem.classList.remove('open'); }

    geoDropdowns.forEach((geoDropdown) => {

        const redirectStoreObj = geoDropdown.querySelector('.js-geo-dropdown__store.js-geo-dropdown__store.js-template');
        const fragment = document.createDocumentFragment();
        const currentStoreHeader = geoDropdown.querySelector('.js-geo-dropdown__current-store-header');
        const currentStore = geoDropdown.querySelector('.js-geo-dropdown__current-store');
        const redirectStores = geoDropdown.querySelector('.js-geo-dropdown__redirect-stores');

        const openGeoDropdownElems = geoDropdown.querySelectorAll('.js-geo-dropdown--open');
        const closeGeoDropdownElems = geoDropdown.querySelectorAll('.js-geo-dropdown--close');
        const toggleGeoDropdownElems = geoDropdown.querySelectorAll('.js-geo-dropdown--toggle');

        openGeoDropdownElems.forEach(openGeoDropdownElem => {
            openGeoDropdownElem.addEventListener('click', () => {
                openGeoDropdown(geoDropdown);
            })
        })

        closeGeoDropdownElems.forEach(closeGeoDropdownElem => {
            closeGeoDropdownElem.addEventListener('click', () => {
                closeGeoDropdown(geoDropdown);
            })
        })

        /*Close whan clicking outside */
        document.addEventListener('click', function(event) {
            var isClickInside = geoDropdown.contains(event.target);

            if (!isClickInside)
            {
                closeGeoDropdown(geoDropdown);
            }
        });

        toggleGeoDropdownElems.forEach(toggleGeoDropdownElem => {
            toggleGeoDropdownElem.addEventListener('click', () => {
                if (geoDropdown.classList.contains('open'))
                {
                    closeGeoDropdown(geoDropdown);
                } else
                {
                    openGeoDropdown(geoDropdown);
                }
            })
        });

        if (dropdownSettings.imagePosition === 'right')
        {
            geoDropdown.classList.add('image-position--right')
        }
        if (dropdownSettings.roundedImages)
        {
            geoDropdown.classList.add('images--rounded')
        }

        // Add content to Dropdown - Current store header
        populateStoreElem(currentStoreHeader, currentStoreData, dropdownSettings.showLanguageTitleInContent, dropdownSettings.showImages, lazyImg = false)
        // Add content to Dropdown - Current store
        populateStoreElem(currentStore, currentStoreData, dropdownSettings.showLanguageTitleInContent, dropdownSettings.showImages)

        // Add content to Dropdown - External stores
        if (externalStoresData)
        {
            externalStoresData.forEach(externalStore => {
                const template = redirectStoreObj.cloneNode(true);
                template.classList.remove('js-template');
                fragment.appendChild(populateStoreElem(template, externalStore, dropdownSettings.showLanguageTitleInContent, dropdownSettings.showImages));
            });
        }

        redirectStoreObj.remove();
        redirectStores.appendChild(fragment);

    })//End foreach



}
else
{
    // Hide dropdowns if empty
    geoDropdowns.forEach((geoDropdown) => {
        geoDropdown.style.display = 'none'
    });
}


/**************************** Cookies ****************************/

function setCookie(name, value, days) {
    console.log(`name: `, name);
    console.log(`value: `, value);
    console.log(`days: `, days);
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));

    const expires = `expires=${date.toUTCString()}`;
    const path = 'path=/';

    document.cookie = `${name}=${value}; ${expires}; ${path}`;
}

function getCookie(name) {
    console.log(`Get name: `, name); 
    const nameEQ = `${ name }=`;
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++)
    {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

/**************************** Popup ****************************/


const popupElem = document.getElementById('geo-popup')


// const { currentCode, regional, international } = window.geoData;


function popUpClose(setGeoCookie = true) {
    popupElem.classList.remove('active');
    if (setGeoCookie)
    {
        setCookie('_geoDismissed', 1, 30);
    }
}

function initGeoPopup(store = null, headline, postline) {
    const popupCurrentStoreTemplate = popupElem.querySelector('.geo-popup__current-store.js-template');
    const popupExternalStoreTemplate = popupElem.querySelector('.geo-popup__external-store.js-template');
    const redirectStores = popupElem.querySelector('.js-geo-popup__stores');
    const fragment = document.createDocumentFragment();
    const closeElems = popupElem.querySelectorAll('.js-geo-popup--close');
    const dismissElems = popupElem.querySelectorAll('.js-geo-popup--dismiss');
    let externalStores = externalStoresData;

    if (headline && postline)
    {
        document.querySelector('.js-geo-popup-headline').innerText = headline;
        document.querySelector('.js-geo-popup-postline').innerText = postline;
    }
    else
    {
        document.querySelector('.js-geo-popup-headline').innerText = currentStoreData.modal.headline;
        document.querySelector('.js-geo-popup-postline').innerText = currentStoreData.modal.postline;
    }

    if (modalSettings.imagePosition === 'right')
    {
        popupElem.classList.add('image-position--right')
    }
    if (modalSettings.roundedImages)
    {
        popupElem.classList.add('images--rounded')
    }
    if (modalSettings.showLanguageTitle === false)
    {
        popupElem.classList.add('images--only')
    }

    switch (modalSettings.modalGeoMatch)
    {
        case 'match':
            const index = externalStoresData.findIndex(x => x === store);

            if (index >= 0)
            {
                externalStores[index].highlight = true
            }
            break;

        case 'matchOnly':
            if (store)
            {
                externalStores = externalStoresData.find(x => x === store)
            }

            break;
    }

    // Add content to Modal - Current store
    populateStoreElem(popupCurrentStoreTemplate, currentStoreData, modalSettings.showLanguageTitle, modalSettings.showImages, lazyImg = false)

    // Add content to Modal - External stores
    if (externalStores && externalStores.length > 1)
    {
        externalStores.forEach(externalStore => {
            const template = popupExternalStoreTemplate.cloneNode(true);
            template.classList.remove('js-template');
            fragment.appendChild(populateStoreElem(template, externalStore, modalSettings.showLanguageTitle, modalSettings.showImages, lazyImg = false));
        });
    }
    else if (externalStores)
    {
        const template = popupExternalStoreTemplate.cloneNode(true);
        template.classList.remove('js-template');
        fragment.appendChild(populateStoreElem(template, externalStores, modalSettings.showLanguageTitle, modalSettings.showImages, lazyImg = false));
    }

    popupExternalStoreTemplate.remove();
    redirectStores.appendChild(fragment);


    closeElems.forEach(closeElem => {
        closeElem.addEventListener('click', function() { popUpClose(false) })
    });
    dismissElems.forEach(dismissElem => {
        dismissElem.addEventListener('click', popUpClose)
    });

    popupElem.classList.add('active');

}

function handleGeo(data) {
    const { country_code, continent_code } = data;

    const storeMatch = stores.find(x => x.countryCodes.includes(country_code))
    const continentStoreMatch = stores.find(x => x.countryCodes.includes(continent_code))
    const internationalStore = stores.find(x => x.isInternational == true)

    if (storeMatch)
    {
        if (storeMatch.isCurrentStore == true) return setCookie('_geoDismissed', 1, 30);

        initGeoPopup(storeMatch, storeMatch.modal.headline, storeMatch.modal.postline)

    } else if (continentStoreMatch)
    {
        if (continentStoreMatch.isCurrentStore == true) return setCookie('_geoDismissed', 1, 30);

        initGeoPopup(continentStoreMatch, continentStoreMatch.modal.headline, continentStoreMatch.modal.postline)
    }
    else if (internationalStore)
    {
        if (internationalStore.isCurrentStore == true) return setCookie('_geoDismissed', 1, 30);

        initGeoPopup(internationalStore, internationalStore.modal.headline, internationalStore.modal.postline)
    }
    else
    {
        initGeoPopup()
    }
}

if (!getCookie('_geoDismissed'))
{
    fetch(`https://get.geojs.io/v1/ip/geo.json`)
        .then((r) => r.json())
        .then((data) => {
            handleGeo(data);
        });
}

